import { Component, inject, Input, output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorReferenceComponent } from '../../components/error-reference/error-reference.component';
import { ModalBodyComponent } from '../modal-body/modal-body.component';

import { BasicModalCta, BasicModalIcon } from './basic-modal.types';

@Component({
  selector: 'app-basic-modal',
  imports: [ErrorReferenceComponent, ModalBodyComponent],
  templateUrl: './basic-modal.component.html',
  styleUrl: './basic-modal.component.scss',
})
export class BasicModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  @Input({ required: true }) public icon!: BasicModalIcon;
  @Input({ required: true }) public title!: string;
  @Input({ required: true }) public description!: string;
  @Input({ required: true }) public mainCtaText!: string;
  @Input() public alternativeCtaText?: string;
  @Input() public closable = false;
  @Input() public errorReference?: string;

  public readonly ctaClick = output<BasicModalCta>();

  protected readonly BasicModalCta = BasicModalCta;
  protected readonly BasicModalIcon = BasicModalIcon;

  protected selectCta(cta: BasicModalCta): void {
    this.ctaClick.emit(cta);
    this.activeModal.close(cta);
  }

  protected closeModal(): void {
    this.selectCta(BasicModalCta.Close);
  }
}
